import React, { useMemo } from "react";
import clsx from "clsx";

import { IAssessmentDistribution } from "../../../state";
import { SCORE_LABELS_JSX } from "../../../constants/assessment-content";

import styles from "./AssessmentDistribution.module.scss";

export type Props = {
  contentId: number;
  distribution: IAssessmentDistribution;
};

const AssessmentDistribution: React.FC<Props> = ({
  contentId,
  distribution,
}) => {
  const distributionData = useMemo(() => {
    const distributionArray = Object.values(
      distribution.by_student_score,
    ).reverse();
    const totalAssessmentUsers = distributionArray.reduce(
      (totalUsers, usernameList) => totalUsers + usernameList.length,
      0,
    );
    return distributionArray.map(usernameList => ({
      usernameList,
      percentage: `${
        totalAssessmentUsers
          ? ((usernameList.length / totalAssessmentUsers) * 100).toFixed(2)
          : 0
      }%`,
    }));
  }, [distribution]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.main}>
        <div className={styles.title}>分布図</div>
        <div className={styles.distribution}>
          <div
            className={clsx(
              styles.percentageColumn,
              styles[`percentageColumn__${contentId}`],
            )}
          >
            {distributionData.map((data, i) => (
              <div key={i} style={{ height: data.percentage }} />
            ))}
          </div>
          <div
            className={clsx(
              styles.distributionDetail,
              styles[`distributionDetail__${contentId}`],
            )}
          >
            {distributionData.map((data, i) => {
              const order = distributionData.length - i;
              return (
                <div className={styles.scoreDistributionItem} key={i}>
                  <p>{(SCORE_LABELS_JSX as any)[`label${order}`]}</p>
                  <span>{data.usernameList.length}</span>
                  <div>
                    {data.usernameList.map((name, nameIndex) => (
                      <span key={nameIndex}>{name}</span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentDistribution;
